module.exports = __webpack_public_path__ + "img/big_1_11.801d6933.png";